module.exports = __webpack_public_path__ + "img/symbol_16.69bf2fa2.png";